import { tExclusiveBrandState } from "./types";

export const kDefaultExclusiveBrand: tExclusiveBrandState = {
  brands: [],
};
